module.exports = __webpack_public_path__ + "static/media/linkedin.f08c524d.png";